import { render, staticRenderFns } from "./MudarClasse.vue?vue&type=template&id=6324bee4&"
import script from "./MudarClasse.vue?vue&type=script&lang=js&"
export * from "./MudarClasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports